import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { formatKoreanPhone } from '@constants/regexp';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useTermCategories from '@hooks/term/useTermCategories';
import useProject from '@hooks/useProject';
import { Link } from '@stackflow/link';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

function MainFooter() {
    const terms = useTermCategories('MAIN');
    const project = useProject();
    const { t } = useTranslation('main', { keyPrefix: 'footer' });
    if (project?.businessProfile) {
        const arr:string[] = [];
        const {
            brandName, bizName, nameEn, representativeName,
            businessRegistrationNumber, salesReportNumber, addrRoad, addrDetail, email, contact,
        } = project.businessProfile;
        if (brandName) {
            arr.push(brandName);
        }
        arr.push(bizName);
        if (nameEn) {
            arr.push(nameEn);
        }
        arr.push(`${t('representativeName')}: ${representativeName}`);
        arr.push(`${t('businessRegistrationNumber')}: ${businessRegistrationNumber}`);
        if (salesReportNumber) {
            arr.push(`${t('salesReportNumber')}: ${salesReportNumber}`);
        }
        arr.push(`${t('address')}: ${addrRoad}${addrDetail ? `, ${addrDetail}` : ''}`);
        arr.push(`${t('email')}: ${email}`);
        if (contact) {
            arr.push(`${t('contact')}: ${formatKoreanPhone(contact)}`);
        }
        const content = arr.join('\n');
        return (
            <Container>
                <Text size='body-long' color={colors.textPrimary}
                    css={css`white-space: pre-wrap; line-height: 1.5;`} >
                    {content}
                </Text>
                <Row spacing={1.5}>
                    {terms?.map((termCategory, index) => (
                        <Fragment key={termCategory.id}>
                            <Link activityName='TermDetailActivity'
                                activityParams={{ termCategoryId: termCategory.id }}>
                                <Text color={colors.textPrimary} css={termCss}>
                                    {termCategory.title}
                                </Text>
                            </Link>
                            {index + 1 !== terms.length && (
                                <Text size='body-long' color={colors.textPrimary}>|</Text>
                            )}
                        </Fragment>
                    ))}
                </Row>
            </Container>
        );
    }
    return (<Fragment/>);
}

const termCss = css`
    font-size: 11px;
    line-height: 1.5;
`;

const Container = styled.div`
    background-color: var(--color-background-base);
    display: flex;
    flex-direction: column;
    padding: var(--spacing-4) 18px 48px;
    row-gap: var(--spacing-2);
    width: 100%;
`;

export default MainFooter;
